import { render, staticRenderFns } from "./GuideRespiratoire.vue?vue&type=template&id=54903fbc&scoped=true"
import script from "./GuideRespiratoire.vue?vue&type=script&lang=js"
export * from "./GuideRespiratoire.vue?vue&type=script&lang=js"
import style0 from "./GuideRespiratoire.vue?vue&type=style&index=0&id=54903fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54903fbc",
  null
  
)

export default component.exports